// extracted by mini-css-extract-plugin
export var button = "Button-module--button--ECaJB";
export var pressed = "Button-module--pressed--x3jLv";
export var secondary = "Button-module--secondary--K3+iG";
export var small = "Button-module--small--F8J1j";
export var smallFont = "Button-module--smallFont--E9TWF";
export var disabled = "Button-module--disabled--ap97x";